import { login } from './api';

// renderLogin draws a password form into the host element. On successful
// login it reloads the app so main.ts re-runs against an authenticated session.
export function renderLogin(host: HTMLElement, onSuccess: () => void): void {
  host.innerHTML = `
    <div class="login">
      <h1>ZionWave</h1>
      <form id="login-form">
        <input id="password" type="password" placeholder="Password" autocomplete="current-password" autofocus />
        <button type="submit">Log in</button>
        <p id="login-error" class="error" hidden>Incorrect password</p>
      </form>
    </div>`;
  const form = host.querySelector<HTMLFormElement>('#login-form')!;
  const error = host.querySelector<HTMLParagraphElement>('#login-error')!;
  form.onsubmit = async (e) => {
    e.preventDefault();
    error.hidden = true;
    const password = host.querySelector<HTMLInputElement>('#password')!.value;
    if (await login(password)) {
      onSuccess();
    } else {
      error.hidden = false;
    }
  };
}
